module.exports = __webpack_public_path__ + "img/grid-outline-circle.4ec226a3.svg";